import { type FC } from 'react';
import { Link } from 'react-router';
import { Button, Group, Paper, Stack, Text, Title } from '@mantine/core';
import { IconArrowLeft } from '@tabler/icons-react';
import { createPayoutCascadesUrl } from '~/entities/payout';

interface CascadeTemplateEditorHeaderProps {
    isNew: boolean;
    templateId?: string;
}

export const CascadeTemplateEditorHeader: FC<CascadeTemplateEditorHeaderProps> = ({ isNew, templateId }) => {
    return (
        <Paper
            p='md'
            radius='md'
            withBorder
        >
            <Stack gap={4}>
                <Button
                    component={Link}
                    to={createPayoutCascadesUrl('templates')}
                    variant='subtle'
                    size='xs'
                    w='fit-content'
                    leftSection={<IconArrowLeft size={16} />}
                >
                    К списку шаблонов
                </Button>

                <Group
                    gap='xs'
                    align='center'
                >
                    <Title
                        order={2}
                        size='h3'
                    >
                        {isNew ? 'Новый шаблон' : 'Шаблон каскада'}
                    </Title>
                </Group>

                {!isNew && (
                    <Text
                        size='sm'
                        c='dimmed'
                    >
                        {templateId}
                    </Text>
                )}
            </Stack>
        </Paper>
    );
};
